import React, { useState, useEffect } from 'react';
        import { motion } from 'framer-motion';
        import { supabase } from '../../config/supabase';
        import SafeIcon from '../../common/SafeIcon';
        import * as FiIcons from 'react-icons/fi';

        const { FiCheck, FiX } = FiIcons;

        const PendingDealsTab = () => {
          const [pendingDeals, setPendingDeals] = useState([]);
          const [loading, setLoading] = useState(true);

          useEffect(() => {
            fetchPendingDeals();
          }, []);

          const fetchPendingDeals = async () => {
            try {
              const { data, error } = await supabase
                .from('deals')
                .select('*, profiles(name, instagram_handle)')
                .eq('status', 'pending')
                .order('created_at', { ascending: false });

              if (error) throw error;
              setPendingDeals(data || []);
            } catch (error) {
              console.error('Error fetching pending deals:', error);
            } finally {
              setLoading(false);
            }
          };

          const handleApprove = async (id) => {
            try {
              const { error } = await supabase.from('deals').update({ status: 'approved' }).eq('id', id);
              if (error) throw error;
              fetchPendingDeals();
            } catch (error) {
              console.error('Error approving deal:', error);
            }
          };

          const handleReject = async (id) => {
            if (window.confirm('Are you sure you want to reject this deal?')) {
              try {
                const { error } = await supabase.from('deals').delete().eq('id', id);
                if (error) throw error;
                fetchPendingDeals();
              } catch (error) {
                console.error('Error rejecting deal:', error);
              }
            }
          };

          if (loading) {
            return (
              <div className="flex items-center justify-center py-12">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
              </div>
            );
          }

          return (
            <div className="space-y-6">
              <div className="flex items-center justify-between">
                <h2 className="text-xl font-semibold text-gray-900">Pending Deals ({pendingDeals.length})</h2>
              </div>
              {pendingDeals.length === 0 ? (
                <div className="text-center py-12">
                  <h3 className="text-lg font-medium text-gray-900 mb-2">No pending deals</h3>
                  <p className="text-gray-600">All deals have been reviewed.</p>
                </div>
              ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  {pendingDeals.map((deal) => (
                    <motion.div
                      key={deal.id}
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="bg-white rounded-lg border border-gray-200 p-6 hover:shadow-md transition-shadow"
                    >
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{deal.title}</h3>
                      <p className="text-gray-600 text-sm mb-4">by {deal.profiles?.name || 'N/A'}</p>
                      <p className="text-gray-700 text-sm mb-4 line-clamp-3">{deal.description}</p>
                      
                      <div className="flex space-x-2">
                        <button onClick={() => handleApprove(deal.id)} className="flex-1 flex items-center justify-center space-x-2 bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors">
                          <SafeIcon icon={FiCheck} />
                          <span>Approve</span>
                        </button>
                        <button onClick={() => handleReject(deal.id)} className="flex-1 flex items-center justify-center space-x-2 bg-red-600 text-white py-2 rounded-lg hover:bg-red-700 transition-colors">
                          <SafeIcon icon={FiX} />
                          <span>Reject</span>
                        </button>
                      </div>
                    </motion.div>
                  ))}
                </div>
              )}
            </div>
          );
        };

        export default PendingDealsTab;